// Hook do pobierania klas encji z podziałem na DevelopmentStudio i Systemowe

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IEntityClassItem {
  text: string;
  value: string;
}

export interface IProcessEntityClassesResponse {
  developmentStudio: IEntityClassItem[];
  system: IEntityClassItem[];
}

interface IApiProcessEntityClassesResponse {
  developmentStudio?: IEntityClassItem[];
  system?: IEntityClassItem[];
  items?: IEntityClassItem[][]; // Format tablicy tablic (items[0] = DevelopmentStudio, items[1] = Systemowe)
}

const getProcessEntityClasses = async (): Promise<IProcessEntityClassesResponse> => {
  try {
    const response: IApiProcessEntityClassesResponse = await axios.get('/dev-studio/process/entity-classes') as unknown as IApiProcessEntityClassesResponse;
    
    // Obsługa formatu z polami bezpośrednio
    if (response.developmentStudio !== undefined || response.system !== undefined) {
      return {
        developmentStudio: Array.isArray(response.developmentStudio) ? response.developmentStudio : [],
        system: Array.isArray(response.system) ? response.system : []
      };
    }
    
    // Obsługa formatu z tablicą tablic w items
    if (response.items && Array.isArray(response.items)) {
      return {
        developmentStudio: Array.isArray(response.items[0]) ? response.items[0] : [],
        system: Array.isArray(response.items[1]) ? response.items[1] : []
      };
    }
    
    // Fallback - puste tablice
    return {
      developmentStudio: [],
      system: []
    };
  } catch (error) {
    console.error('Błąd podczas pobierania klas encji:', error);
    // Zwracamy puste tablice w przypadku błędu
    return {
      developmentStudio: [],
      system: []
    };
  }
};

export const useGetProcessEntityClasses = (
  options?: UseQueryOptions<IProcessEntityClassesResponse, IError>
) => useQuery<IProcessEntityClassesResponse, IError>(
  ['process-entity-classes'],
  getProcessEntityClasses,
  {
    ...options,
    staleTime: 5 * 60 * 1000, // Cache na 5 minut
  }
);
